import { useLang } from "@/context/LanguageContext";

const Footer = () => {
  const { lang, t } = useLang();

  return (
    <>
      <div data-testid="partners-strip" className="border-t border-gold/15 bg-[#F5F0E4]">
        <div className="mx-auto flex max-w-[1600px] flex-col items-center gap-6 px-4 py-10 sm:px-8 lg:flex-row lg:justify-center lg:gap-16 lg:px-16">
          <p className="shrink-0 font-mono text-[10px] uppercase tracking-[0.3em] text-[#6B5F49]">
            {lang === "fr" ? "Avec le soutien de" : "With the support of"}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12">
            <img
              data-testid="partner-logo-region-normandie"
              src="/images/partenaires/logo-region-normandie.png"
              alt="Région Normandie"
              className="h-16 w-auto object-contain sm:h-20"
            />
            <img
              data-testid="partner-logo-ministere-culture"
              src="/images/partenaires/logo-ministere-culture.png"
              alt="Ministère de la Culture"
              className="h-14 w-auto object-contain sm:h-16"
            />
            <img
              data-testid="partner-logo-ministere-esr"
              src="/images/partenaires/logo-ministere-esr.png"
              alt="Ministère de l'Enseignement Supérieur, de la Recherche et de l'Espace"
              className="h-14 w-auto object-contain sm:h-16"
            />
          </div>
        </div>
      </div>
      <footer data-testid="site-footer" className="relative border-t border-gold/15">
      <div className="mx-auto max-w-[1600px] px-4 py-16 text-center sm:px-8 lg:px-16">
        <img src="/images/logo.png" alt="Maison pour l'Art et la Science" className="mx-auto h-16 w-16 object-contain" />
        <p data-testid="footer-motto" className="mt-6 font-serif text-3xl font-light italic text-parchment sm:text-4xl">
          {t.footer.motto}
        </p>
        <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-sand">
          {t.footer.operated} <span className="text-gold">VIVA ARTIST</span>
        </p>
        <div className="mx-auto mt-10 h-px w-24 bg-gold/30" />
        <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-sand/80">
          Maison Guillaume le Conquérant pour l'Art et la Science · Prieuré Saint-Léonard de Vains
        </p>
        <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-sand/60">
          © 2026 Maison pour l'Art et la Science · {t.footer.rights}
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[10px] font-light leading-relaxed text-sand/50">
          {t.footer.music_credit}
        </p>
      </div>
    </footer>
    </>
  );
};

export default Footer;
